// extracted by mini-css-extract-plugin
export default {"addSection":"ContentSection_addSection__WNsjI","addSectionContainer":"ContentSection_addSectionContainer__H-SEk","container":"ContentSection_container__xGHqp"};